import { render, staticRenderFns } from "./WorkerPositionsTab.vue?vue&type=template&id=2fd13477"
import script from "./WorkerPositionsTab.vue?vue&type=script&lang=ts"
export * from "./WorkerPositionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports